import { TENANT_NAMES } from '@constants';

export const initialColumns = [
  {
    columnId: 'procurementStage',
    key: 'procurementStage',
    label: 'Stage',
    width: 100,
    value: true,
    resizable: true,
  },
  {
    columnId: 'internalId',
    key: 'internalId',
    label: 'Internal ID',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'skuId',
    key: 'skuId',
    label: 'SKU ID',
    width: 100,
    value: true,
    resizable: true,
  },
  {
    columnId: 'vehicleOwnership',
    key: 'vehicleOwnership',
    label: 'Vehicle Ownership',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'tenant',
    key: 'tenant',
    label: 'Holding company',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'description',
    key: 'description',
    label: 'Description',
    width: 300,
    value: true,
    resizable: true,
  },
  {
    columnId: 'color',
    key: 'color',
    label: 'Colour',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'condition',
    key: 'condition',
    label: 'Condition',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'kilometersAtPurchase',
    key: 'kilometersAtPurchase',
    label: 'Kilometers At Purchase',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'vin',
    key: 'vin',
    label: 'VIN',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'plate',
    key: 'plate',
    label: 'Plate',
    width: 100,
    value: true,
    resizable: true,
  },
  {
    columnId: 'location',
    key: 'location',
    label: 'Location',
    width: 250,
    value: true,
    resizable: true,
  },
  {
    columnId: 'reservationType',
    key: 'reservationType',
    label: 'Reservation Type',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'supplierOrderId',
    key: 'supplierOrderId',
    label: 'Order ID',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'orderDate',
    key: 'orderDate',
    label: 'Order Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'dealer',
    key: 'dealer',
    label: 'Dealer',
    width: 140,
    value: true,
    resizable: true,
  },
  {
    columnId: 'cancelledDate',
    key: 'cancelledDate',
    label: 'Cancellation Date',
    width: 160,
    value: true,
    resizable: true,
  },
  {
    columnId: 'erfudd',
    key: 'erfudd',
    label: 'ERFUDD',
    width: 160,
    value: true,
    resizable: true,
  },
  {
    columnId: 'retailPrice',
    key: 'retailPrice',
    label: 'Retail Price',
    width: 160,
    value: true,
    resizable: true,
  },
  {
    columnId: 'retailPriceBeforeTax',
    key: 'retailPriceBeforeTax',
    label: 'Retail Price Before Tax',
    width: 160,
    value: true,
    resizable: true,
  },
  {
    columnId: 'vat',
    key: 'vat',
    label: 'VAT',
    width: 100,
    value: true,
    resizable: true,
  },
  {
    columnId: 'extras',
    key: 'extras',
    label: 'Extras',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'extrasPrice',
    key: 'extrasPrice',
    label: 'Extras Price',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'specialClassificationFee',
    key: 'specialClassificationFee',
    label: 'ETT (Ειδικό τέλος ταξινόμησης)',
    width: 150,
    value: true,
    resizable: true,
  },
  {
    columnId: 'discountPercentage',
    key: 'discountPercentage',
    label: 'Discount Percentage (%)',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'discountWithoutVat',
    key: 'discountWithoutVat',
    label: 'Discount',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'agreedPurchasePrice',
    key: 'agreedPurchasePrice',
    label: 'Agreed P.P.',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'finalPurchasePrice',
    key: 'finalPurchasePrice',
    label: 'Final P.P.',
    width: 120,
    value: true,
    resizable: true,
  },
  {
    columnId: 'agreedCustomsDate',
    key: 'agreedCustomsDate',
    label: 'Agreed Customs Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'estimatedCustomsDate',
    key: 'estimatedCustomsDate',
    label: 'Estimated Customs Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'customsEntryDate',
    key: 'customsEntryDate',
    label: 'Customs Entry Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'plannedDownpaymentDate',
    key: 'plannedDownpaymentDate',
    label: 'Planned Downpayment Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'delayReason',
    key: 'delayReason',
    label: 'Delay Reason',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'licenseIssuanceDate',
    key: 'licenseIssuanceDate',
    label: 'License Issuance Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'insuranceProvider',
    key: 'insuranceProvider',
    label: 'Insurance Provider',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'insuranceDate',
    key: 'insuranceDate',
    label: 'Insurance Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'insuranceRenewalDate',
    key: 'insuranceRenewalDate',
    label: 'Insurance Renewal Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'plannedReceiptDate',
    key: 'plannedReceiptDate',
    label: 'Planned Receipt Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'receiptDate',
    key: 'receiptDate',
    label: 'Receipt Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'sourcingType',
    key: 'sourcingType',
    label: 'Sourcing Type',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'financingType',
    key: 'financingType',
    label: 'Financing Type',
    width: 190,
    value: true,
    resizable: true,
  },
  {
    columnId: 'financingProvider',
    key: 'financingProvider',
    label: 'Financing Provider',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'vehiclePurchaseDate',
    key: 'vehiclePurchaseDate',
    label: 'Vehicle Purchase Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'leaseStartDate',
    key: 'leaseStartDate',
    label: 'Lease Start Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'leaseMonthlyInstallment',
    key: 'leaseMonthlyInstallment',
    label: 'Lease Monthly installment',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'defleetedDate',
    key: 'defleetedDate',
    label: 'Defleeted Date',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'defleetPriority',
    key: 'defleetPriority',
    label: 'Defleet Priority',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'monthOfDefleet',
    key: 'monthOfDefleet',
    label: 'Month of Defleet',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'invoiceNumber',
    key: 'invoiceNumber',
    label: 'Invoice Number',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'netPrice',
    key: 'netPrice',
    label: 'Net Price',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'registrationTax',
    key: 'registrationTax',
    label: 'Registration Tax',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'invoiceDetailsVat',
    key: 'invoiceDetailsVat',
    label: 'Invoice Vat',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'transferFee',
    key: 'transferFee',
    label: 'Transfer Fee',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'plateReleaseFee',
    key: 'plateReleaseFee',
    label: 'Plate Release Fee',
    width: 180,
    value: true,
    resizable: true,
  },
  {
    columnId: 'categoryClass',
    key: 'categoryClass',
    label: 'Category Class',
    width: 180,
    value: true,
    resizable: true,
  },
];

export const initialHiddenFieldsPerTab = {
  created: {
    color: false,
    condition: false,
    kilometersAtPurchase: false,
    vin: false,
    plate: false,
    currentLocation: false,
    orderId: false,
    orderDate: false,
    cancelledDate: false,
    erfudd: false,
    retailPrice: false,
    retailPriceBeforeTax: false,
    vat: false,
    extras: false,
    extrasPrice: false,
    specialClassificationFee: false,
    discountPercentage: false,
    discount: false,
    agreedPurchasePrice: false,
    finalPurchasePrice: false,
    agreedCustomsDate: false,
    estimatedCustomsDate: false,
    customsEntryDate: false,
    plannedDownpaymentDate: false,
    licenseIssuanceDate: false,
    insuranceProvider: false,
    insuranceDate: false,
    plannedReceiptDate: false,
    receiptDate: false,
    sourcingType: false,
    financingType: false,
    financingProvider: false,
    vehiclePurchaseDate: false,
    leaseStartDate: false,
    leaseMonthlyInstallment: false,
    defleetedDate: false,
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  order: {
    color: false,
    condition: false,
    kilometersAtPurchase: false,
    vin: false,
    plate: false,
    currentLocation: false,
    orderId: false,
    orderDate: false,
    cancelledDate: false,
    erfudd: false,
    retailPrice: false,
    retailPriceBeforeTax: false,
    vat: false,
    extras: false,
    extrasPrice: false,
    specialClassificationFee: false,
    discountPercentage: false,
    discount: false,
    finalPurchasePrice: false,
    agreedCustomsDate: false,
    customsEntryDate: false,
    plannedDownpaymentDate: false,
    licenseIssuanceDate: false,
    insuranceProvider: false,
    insuranceDate: false,
    plannedReceiptDate: false,
    receiptDate: false,
    sourcingType: false,
    financingType: false,
    financingProvider: false,
    vehiclePurchaseDate: false,
    leaseStartDate: false,
    leaseMonthlyInstallment: false,
    defleetedDate: false,
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  customs: {
    color: false,
    condition: false,
    kilometersAtPurchase: false,
    vin: false,
    plate: false,
    currentLocation: false,
    orderId: false,
    orderDate: false,
    cancelledDate: false,
    erfudd: false,
    retailPrice: false,
    retailPriceBeforeTax: false,
    vat: false,
    extras: false,
    extrasPrice: false,
    specialClassificationFee: false,
    discountPercentage: false,
    discount: false,
    agreedPurchasePrice: false,
    finalPurchasePrice: false,
    agreedCustomsDate: false,
    plannedDownpaymentDate: false,
    licenseIssuanceDate: false,
    insuranceProvider: false,
    insuranceDate: false,
    plannedReceiptDate: false,
    receiptDate: false,
    sourcingType: false,
    financingType: false,
    financingProvider: false,
    vehiclePurchaseDate: false,
    leaseStartDate: false,
    leaseMonthlyInstallment: false,
    defleetedDate: false,
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  payment: {
    color: false,
    condition: false,
    kilometersAtPurchase: false,
    vin: false,
    plate: false,
    currentLocation: false,
    orderId: false,
    orderDate: false,
    dealer: false,
    cancelledDate: false,
    erfudd: false,
    retailPrice: false,
    retailPriceBeforeTax: false,
    vat: false,
    extras: false,
    extrasPrice: false,
    specialClassificationFee: false,
    discountPercentage: false,
    discount: false,
    agreedPurchasePrice: false,
    finalPurchasePrice: false,
    agreedCustomsDate: false,
    customsEntryDate: false,
    licenseIssuanceDate: false,
    insuranceProvider: false,
    insuranceDate: false,
    plannedReceiptDate: false,
    receiptDate: false,
    sourcingType: false,
    financingType: false,
    financingProvider: false,
    vehiclePurchaseDate: false,
    leaseStartDate: false,
    leaseMonthlyInstallment: false,
    defleetedDate: false,
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  procurement: {
    color: false,
    condition: false,
    kilometersAtPurchase: false,
    vin: false,
    plate: false,
    currentLocation: false,
    orderId: false,
    orderDate: false,
    dealer: false,
    cancelledDate: false,
    erfudd: false,
    agreedCustomsDate: false,
    estimatedCustomsDate: false,
    customsEntryDate: false,
    licenseIssuanceDate: false,
    insuranceProvider: false,
    insuranceDate: false,
    insuranceRenewalDate: false,
    plannedReceiptDate: false,
    receiptDate: false,
    sourcingType: false,
    financingType: false,
    financingProvider: false,
    vehiclePurchaseDate: false,
    leaseStartDate: false,
    leaseMonthlyInstallment: false,
    defleetedDate: false,
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  dealer: {
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  cancelled: {
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  defleeted: {
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
  all: {
    invoiceNumber: false,
    netPrice: false,
    registrationTax: false,
    invoiceDetailsVat: false,
    transferFee: false,
    plateReleaseFee: false,
    reservationType: false,
    categoryClass: false,
  },
};

export const vehicleOwnershipOptions = [
  'Instacar',
  'Instachr',
  'Instapath',
  'Motorlease',
  'NBG Leasing',
  'Karenta',
  'Eurobank Leasing VGC',
  'Πειραιώς Leasing',
  'Autobesikos',
  'Hertz / Autohellas',
  'Kinsen',
  'EKKA',
  'Avance',
  'Instacar / Hertz',
];

export const tenantOptions = [
  { label: 'None', value: '' },
  ...Object.keys(TENANT_NAMES).map((key) => ({
    label: TENANT_NAMES[key],
    value: key,
  })),
];

export const currentLocationOptions = [
  'None',
  'Instacar Pigasou',
  'instacar point - Aspropirgos',
  'Instacar Employee',
  'Repair',
  'Kineo',
];

export const financingTypeOptions = [
  'Bank Loan 18M',
  'Bank Loan 24M',
  'Bank Loan 36M',
  'Bank Loan 48M',
  'Bond Loan',
  'Cash',
  'Finance Lease 24M',
  'Finance Lease 36M',
  'Finance Lease 48M',
  'Operating Lease 6M',
  'Operating Lease 12M',
  'Operating Lease 24M',
  'Operating Lease 36M',
  'Operating Lease 36M+12M',
  'Operating Lease 48M',
];

export const commonColumnProps = {
  display: 'flex',
  flex: 1,
  align: 'left',
  headerAlign: 'left',
  filterable: false,
  sortable: false,
  editable: false,
  minWidth: 180,
  renderCell: (params) => params.value || '-',
};
